var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96273 4.52275C0.326526 6.15895 0.326526 8.81176 1.96273 10.448L4.5228 13.008C6.159 14.6442 8.81181 14.6442 10.448 13.008L13.0081 10.448C14.6443 8.81176 14.6443 6.15895 13.0081 4.52275L10.448 1.96268C8.81181 0.326475 6.159 0.326474 4.5228 1.96268L1.96273 4.52275Z",
    fill: "#F48D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.99a814da5a50370dc21a1d9ac483c7fa.svg";
export { ForwardRef as ReactComponent };